import React, { useState, useRef, useEffect } from 'react';

// Tekstfelt med rullegardin av tidligere brukte verdier ("kategorier").
// Kategoriene er IKKE lagret separat noe sted — de utledes live fra
// eksisterende fangster (options-prop). Det betyr at en kategori
// automatisk forsvinner fra lista når ingen fangster lenger bruker den,
// og en ny kategori dukker opp så snart man lagrer en fangst med den.
export default function CategoryInput({
  value,
  onChange,
  options = [],
  placeholder = '',
  maxLength,
  inputClassName = ''
}) {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    function handleClick(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  const trimmed = value.trim();
  const filtered = trimmed
    ? options.filter(opt => opt.toLowerCase().includes(trimmed.toLowerCase()))
    : options;

  const showAddNew = trimmed.length > 0 &&
    !options.some(opt => opt.toLowerCase() === trimmed.toLowerCase());

  return (
    <div ref={wrapperRef} className="relative">
      <input
        type="text"
        maxLength={maxLength}
        value={value}
        placeholder={placeholder}
        className={inputClassName}
        onFocus={() => setOpen(true)}
        onChange={e => onChange(e.target.value)}
      />
      {open && (filtered.length > 0 || showAddNew) && (
        <div className="absolute left-0 right-0 top-full mt-1 bg-white border border-[#D1CCC0] rounded-md shadow-lg max-h-48 overflow-y-auto z-20">
          {filtered.slice(0, 30).map(opt => (
            <button
              key={opt}
              type="button"
              onClick={() => { onChange(opt); setOpen(false); }}
              className="w-full text-left px-4 py-2 font-serif italic text-sm text-[#3B4D3C] hover:bg-[#F8F5F0] transition-colors"
            >
              {opt}
            </button>
          ))}
          {showAddNew && (
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="w-full text-left px-4 py-2 font-sans text-xs text-[#E67E22] font-semibold hover:bg-[#F8F5F0] transition-colors border-t border-[#D1CCC0]/50"
            >
              + Legg til "{trimmed}" som ny kategori
            </button>
          )}
        </div>
      )}
    </div>
  );
}
